<template>
  <div class="bg-black height-100 watch-info">
    <div class="main-play">
      <div class="flex play-tit">
        <!-- <a-row type="flex" class="title" justify="space-between" align="middle"> -->
        <div :span="12" class="flex align-center">
          <span class="schedule-name">{{ videoData.scheduleName }}</span>
          <!-- <span class="middle">{{ watchNum && watchNum.watchNum ? watchNum.watchNum : 0 }}人在线</span> -->
        </div>
        <div :span="6" class="flex align-center">
          <div @click="goAsk()" class="flex align-center cursor" style="margin-right: 20px">
            <img src="./img/ask-icon.png" class="icon-play" />提问
          </div>
          <div @click="goEvaluate()" class="flex align-center cursor" v-if="isShowEva" style="margin-right: 20px">
            <img src="./img/evaluate-icon.png" class="icon-play" />评价
          </div>
          <div @click="gpResource()" class="flex align-center cursor">
            <img src="./img/resource-icon.png" class="icon-play" />资源
          </div>
          <div class="header_title">
            <h1 class="icon_container">
              <div class="icon" v-if="userInfo.nickName">
                <img :src="userInfo.headImgUrl" alt="" class="stu-logo" />
              </div>
              <span>{{ userInfo.nickName }}</span>
            </h1>
          </div>
        </div>
      </div>
    </div>

    <div id="watch" class="watch-box" v-if="videoData.activityStatus === '1'">
      <!-- <Loading /> -->
      <div v-if="loaded" ref="main" id="main">
        <!-- <HorseLamp /> -->
        <div class="class-panel">
          <WhiteBorad />

          <div v-if="showStartBtn" class="start-btn" @click="handleClassStart">
            上课
          </div>
        </div>

        <div class="media-panel">
          <div class="wrap">
            <!-- 老师播放器 -->
            <TeacherPlayer :videoData="videoData" />
            <!-- <SelfPlayer></SelfPlayer> -->
            <!-- 互动区 -->
            <InteractionPanel />
          </div>
          <!-- 文档列表 -->
          <DocList v-if="isTeacher" />
        </div>

        <div class="footer" style="z-index: 1">
          <SettingPanel />
          <FunctionPanel />
        </div>

        <!-- 模态框组件 -->
        <ModalPanel />
        <Interaction />
      </div>
    </div>
    <div class="watch-empty" v-if="videoData.activityStatus === '2'">
      <img src="./img/empty.png" class="icom-empty" />
      <div class="empty-hint">课程已下课</div>
    </div>
    <ask-modal :visible.sync="askVisible" @refresh="refresh"></ask-modal>
    <evaluate-modal :visible.sync="evaluateVisible" @refresh="evaluatRefresh"
      :scheduleId="studentData.scheduleId"></evaluate-modal>
    <resource :pushType="videoData.pushType" :classesName="videoData.classesName" v-if="videoData.activityStatus !== 0"
      :visible.sync="resourceVisible" :activityInfo="videoData" :planclassesId="studentData.planclassesId"
      @getResorce="getResorce" :resourceList="resourceList" @analysisPPt="analysisPPt" @closeResource="closeResource">
    </resource>
  </div>
</template>

<script>
import Vue from 'vue'
// // loading组件，进教室之前的准备工作
// import Loading from './components/Loading.vue'
// // 白板组件
import WhiteBorad from './components/WhiteBoard.vue'
// // 设置面板：扬声器、麦克风、摄像头、设置
import SettingPanel from './components/SettingPanel'
// // 交互面板：用户列表、聊天、发言列表
import InteractionPanel from './components/InteractionPanel'
// // 老师播放器
import TeacherPlayer from './components/TeacherPlayer'
import SelfPlayer from './components/SelfPlayer'
// // 功能面板：直播间的一些功能，举手、屏幕共享、弹幕之类
import FunctionPanel from './components/FunctionPanel'
// // 模态框组件，在老师端发起互动后显示
import ModalPanel from './components/ModalPanel'
// // 跑马灯组件
// import HorseLamp from './components/HorseLamp'
// // 文档列表
import DocList from './components/DocList'
// // 话术
import language from './language/main.js'
// // 互动组件
import Interaction from './components/Interaction.vue'
import resource from '@/components/wacthModule/resource'
import askModal from '@/components/wacthModule/askModal'
import evaluateModal from '@/components/evaluateModal/evaluateModal'
// const BJY = window.BJY
const eventEmitter = BJY.eventEmitter
const auth = BJY.auth
const store = BJY.store
const config = BJY.config
eventEmitter.OPEN_SETTING_DIALOG_TRIGGER = 'open_setting_dialog'

export default {
  name: 'watchLiveBjy',
  components: {
    // Loading,
    WhiteBorad,
    SettingPanel,
    InteractionPanel,
    TeacherPlayer,
    FunctionPanel,
    // HorseLamp,
    ModalPanel,
    DocList,
    Interaction,
    SelfPlayer,
    resource,
    askModal,
    evaluateModal,
  },
  data() {
    return {
      videoData: {},
      userInfo: Vue.ls.get('USER_INFO'),
      loaded: false,
      webrtc: 1,
      isTeacher: false,
      showStartBtn: false,
      surveyUrl: '',
      isShowEva: true,
      watchNum: null,
      studentData: {},
      watchTimer: null,
      scanBeginTime: 0,
      resourceList: [],
      doExerciseVisible: true,
      evaluateVisible: false,
      askVisible: false,
      resourceVisible: false,
      groupInfo: {}
    }
  },
  mounted() {
    // webrtc 添加页面交互
    // if (this.webrtc) {
    //   this.$Dialog
    //     .show({
    //       title: '提示',
    //       content: `正在进入教室。。。`,
    //       confirmText: '确认',
    //     })
    //     .then(() => {
    //       console.log('教室内首次交互完成')
    //     })
    //     .catch((e) => {
    //       console.log(e)
    //     })
    // }
    // const that = this
    // setTimeout(function () {
    //     // this.$refs.TeacherPlayer.pptVideoSwitch()
    //     if (that.videoData.scene === 'video') {
    //       that.pptVideoSwitch()
    //       $('#whiteboard').css({ 'width': '100%', 'left': '0', 'right': '0' })
    //       $('.live-teacher-player').css({ 'display': 'none' })
    //       $('.interaction').css({ 'top': '0' })
    //       $('.bjy-toggle').css({ 'display': 'none' })
    //     }
    // }, 1500)
  },
  created() {
    // this.initData()
    // 初始化教室
    this.initBjy()
    document.querySelector('body').setAttribute('style', 'overflow: auto')
  },
  destroyed() {
    this.saveWatchTime(1)
    console.log('disconnect............')
    if (this.watchTimer) {
      clearInterval(this.watchTimer)
    }
  },
  methods: {
    initBjy() {
      // 绑定事件
      var $body = $('body')

      store.watch(
        'class.started',
        (started) => {
          this.showStartBtn = auth.isTeacher() && !started
        },
        true
      )

      eventEmitter.one(eventEmitter.CLASSROOM_CONNECT_TRIGGER, (event, data) => {
        // 初始化扩展
        var extension = BJY.getExtension()
        if (BJY.browser.wechat) {
          extension = BJY.Player.html
        }
        // PC 不支持 m3u8，这里强制使用 flv
        if (extension === BJY.Player.html) {
          extension.extensions.useFlv = true
        }
        // 如果您使用的是webrtc拓展的话，请确保引入了realtimecat.js这个依赖，否则此处会报undefined：RTCat
        extension.init().then(() => {
          eventEmitter.trigger(eventEmitter.CLASSROOM_CONNECT_TRIGGER, data)
        })
        return false
      })
      eventEmitter
        .on(eventEmitter.CLASSROOM_CONNECT_FAIL, () => {
          alert(language.ROOM_SERVER_CONNECT_FAIL)
        })
        .on(eventEmitter.LOGIN_CONFLICT, () => {
          alert(language.LOGIN_CONFLICT)
        })
        // 监听初始化事件，初始化组件
        // 请将所有的组件创建逻辑写于此回调函数之中
        .one(eventEmitter.VIEW_RENDER_TRIGGER, () => {
          // 注意，在VIEW_RENDER_TRIGGER事件触发后再去加载教室里面的组件
          this.loaded = true
          this.isTeacher = auth.isTeacher()
          eventEmitter.trigger(eventEmitter.DOC_ALL_REQ)

          if (auth.isTeacher() || auth.isAssistant()) {
            store.set('class.speakState', config.SPEAK_STATE_FREE)
          } else {
            store.set('class.speakState', config.SPEAK_STATE_LIMIT)
          }

          if (auth.isPresenter() && store.get('class.started')) {
            setTimeout(() => {
              var player = BJY.Player.instances[BJY.store.get('user.id')]
              BJY.userPublish.setDevice(player, !player.videoOn, !player.audioOn)
            }, 1000)
          }

          if (auth.isStudent()) {
            $body.addClass('student')
          }

          // 初始化webRTC的屏幕扩展
          // 如果你需要使用到webrtc屏幕共享的话，记得在index.html里面引入对应的js依赖
          if (auth.isWebRTC()) {
            BJY.ScreenShareExtensionWebrtc.init()
          }

          // 转播
          if (BJY.is.isMixWebRTC() && !!store.get('partner.liveRoomBroadcast')) {
            var TransferClass = BJY.TransferClass
            var transferClass = new TransferClass()
            transferClass && transferClass.get()
          }
        })
        .one(eventEmitter.LOADING_PANEL_END, () => {
          // 进度条加载完成再显示ui
          $('#main').css('opacity', 1)
        })
        .on(eventEmitter.CLASS_END, () => {
          // 下课后所有人自动关闭音视频
          eventEmitter.trigger(eventEmitter.MEDIA_SWITCH_TRIGGER, {
            audioOn: false,
            videoOn: false,
          })
        })
        .on(eventEmitter.CLASS_START, () => {
          // 老师上课自动打开音视频
          if (auth.isPresenter()) {
            setTimeout(() => {
              var player = BJY.Player.instances[BJY.store.get('user.id')]
              BJY.userPublish.setDevice(player, !player.videoOn, !player.audioOn)
            }, 1000)
          }
        })
        .on(eventEmitter.CLASSROOM_CONNECT_SUCCESS, (event, data) => {
          // data.reconnect 是否为断线重连
        })
        // 踢出教室
        .on(eventEmitter.COMMAND_RECEIVE, (event, data) => {
          if (
            data.command &&
            data.command.command_type === 'logout' &&
            data.toId === store.get('user.id')
          ) {
            alert('你已被踢出教室')
            location.reload()
          }
        })
        // 课前问卷
        .on(eventEmitter.INTERFACE_FETCH_SUCCESS, () => {
          var isSdk = true
          // 设置为 false 时，检测到需要填写问卷时，会直接重定向
          var noRedirect = true
          BJY.checkQuestionnaireAndTurn(
            store.get('class.id'),
            store.get('token'),
            store.get('user.type'),
            store.get('user.number'),
            isSdk,
            noRedirect
          ).then((data) => {
            if (data && data.isNeedFill) {
              this.surveyUrl = data.url
              var me = this
              window.onmessage = function (e) {
                // console.log('onmessage', e.data)
                var data = e.data
                if (data.type === 'surveyClose' && data.isSubmit) {
                  me.surveyUrl = ''
                }
              }
            }
          })
        })
      this.initData()
    },
    initData() {
      this.userInfo = Vue.ls.get('USER_INFO')
      if (this.$route.query) {
        this.studentData = this.$route.query
      }
      if (this.watchTimer) {
        clearInterval(this.watchTimer)
      }
      // if (!window.PolyvLiveSdk) {
      //   loadJs(this.playerJsSrc, this.loadPlayer)
      // }
      // console.log('scanBeginTime', parseInt(new Date().getTime()))
      this.scanBeginTime = parseInt(new Date().getTime())
      this.getStuVieoCheck()
      this.getResorce()
    },
    // 获取视频/直播详情数据
    async getStuVieoCheck() {
      // const res = await this.$http.get(
      //   `/b/classes/web/bjy/live/schedule/info/${this.studentData.classesId}/${this.studentData.scheduleId}`
      // )
      const res = await this.$http.get(
        `/b/classes/web/bjy/live/schedule/group/info/${this.studentData.planclassesId}/${this.studentData.classesId}/${this.studentData.scheduleId}`
      )
      this.videoData = res
      this.isShowEva = !res.hasComment
      // this.$refs.TeacherPlayer.pptVideoSwitch()
      // this.pptVideoSwitch()
      // console.log('this.videoData', this.videoData)
      const time = res
      if (time.startTime && time.endTime) {
        const start = time.startTime.split(' ')
        const end = time.endTime.split(' ')
        res.end = start[0] === end[0] ? end[1] : res.endTime
      }
      const that = this
      this.watchTimer = setInterval(() => {
        // this.saveLastWatchTime()
        that.saveWatchTime()
      }, 60000)
      this.initClassRoon()
    },
    initClassRoon() {
      // 默认demo教室-学生端
      // var options = {
      //   prefixName: 'tiansujing',
      //   env: 'production',
      //   room_id: '23013165839806',
      //   user_number: '187',
      //   user_avatar: 'https://img.baijiayun.com/0bjcloud/live/avatar/v2/121.jpg',
      //   user_name: 'test',
      //   user_role: 0,
      //   sign: '1bdb90478e5523e0e3a3714967575c34',
      //   webrtc: 1,
      // }
      var options = {
        prefixName: 'tiansujing',
        env: 'production',
        room_id: this.videoData.channelId,
        user_number: this.videoData.number,
        user_avatar: this.videoData.avatar,
        user_name: this.videoData.name,
        user_role: 0,
        sign: this.videoData.sign,
        webrtc: 1,
        group: this.videoData.groupId
      }

      if (location.href.includes('teacher=1')) {
        options = Object.assign(options, {
          user_name: this.videoData.name,
          user_role: 0,
          user_number: this.videoData.number,
          sign: this.videoData.sign,
        })
      }

      // debug 模式支持输入传送门链接进入
      // 非webrtc大班课需要在url后拼上 &webrtc=0
      if (location.href.includes('debug=1')) {
        var url = prompt('输入教室链接进入教室')
        options = Object.assign(options, this.urlParser(url))
        // console.log(options)
      }

      var classOption = {
        // 必须为字符串
        id: options.room_id,
        // 学生默认限制发言
        speakState: BJY.config.SPEAK_STATE_LIMIT,
      }
      if (Number(options.webrtc)) {
        classOption.webrtcType = Number(options.webrtc)
      }
      this.webrtc = classOption.webrtcType

      BJY.init({
        env: options.env,
        privateDomainPrefix: options.prefixName,
        class: classOption,
        user: {
          number: options.user_number,
          avatar: decodeURIComponent(options.user_avatar),
          name: decodeURIComponent(options.user_name),
          type: Number(options.user_role),
          group: options.group
        },
        teacher: {
          number: options.user_number,
          avatar: decodeURIComponent(options.user_avatar),
          name: decodeURIComponent(options.user_name),
          type: Number(options.user_role),
        },
        sign: options.sign,
      })
      const list = BJY.data.media.getCDNQualityList()
      console.log('list', list)
      // setTimeout(function () {
      //     this.$nextTick(async () => {
      //     // this.$refs.TeacherPlayer.pptVideoSwitch()
      //     if (this.videoData.scene === 'video') {
      //       this.pptVideoSwitch()
      //       $('#whiteboard').css({ 'width': '100%', 'left': '0', 'right': '0' })
      //       $('.live-teacher-player').css({ 'display': 'none' })
      //       $('.interaction').css({ 'top': '0' })
      //       $('.bjy-toggle').css({ 'display': 'none' })
      //     }
      //     })
      //    }, 5000)
    },
    // 支持解析输入的url进教室
    urlParser(url) {
      var params = {}
      if (url) {
        try {
          var queryStr = url.split('?')[1]
          var paramList = queryStr.split('&')
          paramList.forEach((item) => {
            var pair = item.split('=')
            params[pair[0]] = pair[1]
          })
          // 区分环境
          params.env = this.getEnv(url)
          // 个性域名
          params.prefixName = url.split('.')[0].split('//')[1]
        } catch (e) {
          alert('url格式错误，已进入默认教室')
        }
      }
      return params
    },
    getEnv(url) {
      // 获取环境
      var hostName = url.match(/\/\/(.*)\./)[1]
      if (
        /test/.test(hostName) ||
        /localhost/.test(hostName) ||
        /\d{1,3}\.\d{1,3}\.\d{1,3}/.test(hostName)
      ) {
        return 'test'
      }
      if (/beta/.test(hostName)) {
        return 'beta'
      }
      if (/www/.test(hostName)) {
        return ''
      }
      return ''
    },
    handleClassStart() {
      eventEmitter.trigger(eventEmitter.CLASS_START_TRIGGER)
    },
    async saveWatchTime() {
      const scanEndTime = parseInt(new Date().getTime())
      console.log('time', scanEndTime - this.scanBeginTime)
      const params = {
        activityId: this.videoData.activityId,
        classesId: this.studentData.classesId,
        scheduleId: this.studentData.scheduleId,
        planclassesId: this.studentData.planclassesId ? this.studentData.planclassesId : '',
        state: this.videoData.activityStatus,
        startTimeStamp: this.scanBeginTime,
        endTimeStamp: scanEndTime,
        startTime: 0,
        endTime: 0,
        watchDuration: scanEndTime - this.scanBeginTime,
        videoPlayedTime: scanEndTime - this.scanBeginTime,
        scanBeginTime: scanEndTime
      }
      // console.log('params', params)
      await this.$http.post(`/b/classes/live/v2/saveVideoProgressForPc`, params)
      this.scanBeginTime = scanEndTime
    },
    async getResorce() {
      this.resourceList = await this.$http.get('/b/classes/web/stu/schedule/resource/v2/' + this.studentData.scheduleId)
    },
    goAsk() {
      this.askVisible = true
    },
    refresh() {
      // console.log(this.$refs.postRef)
      this.askVisible = false
    },
    goEvaluate() {
      this.evaluateVisible = true
    },
    evaluatRefresh() {
      // console.log(this.$refs.postRef)
      this.evaluateVisible = false
      this.isShowEva = false
    },
    gpResource() {
      this.resourceVisible = true
    },
    closeResource() {
      this.resourceVisible = false
    },
    analysisPPt(urls) {
      this.itemUrls = urls
      if (!this.itemUrls || this.itemUrls.length < 1) {
        this.$message.info('当前讲义没有数据')
      }
    },
    // swap(presenterCameraNode, whiteboardNode) {
    //   var presenterCameraParentNode = presenterCameraNode.parentNode
    //   var whiteboardParentNode = whiteboardNode.parentNode
    //   var presenterCameraPlaceholder = document.createElement('div')
    //   var whiteboardPlaceholder = document.createElement('div')

    //   presenterCameraParentNode.insertBefore(
    //     presenterCameraPlaceholder,
    //     presenterCameraNode
    //   )
    //   whiteboardParentNode.insertBefore(whiteboardPlaceholder, whiteboardNode)

    //   whiteboardNode &&
    //     presenterCameraParentNode.insertBefore(
    //       whiteboardNode,
    //       presenterCameraPlaceholder
    //     )
    //   presenterCameraNode &&
    //     whiteboardParentNode.insertBefore(presenterCameraNode, whiteboardPlaceholder)

    //   presenterCameraParentNode.removeChild(presenterCameraPlaceholder)
    //   whiteboardParentNode.removeChild(whiteboardPlaceholder)
    // },

    // // 切换ppt与主讲视频位置，如需同步切换，可通过自定义信令实现
    // pptVideoSwitch() {
    //   const presenterDom = $('.live-teacher-player-placeholder')[0]
    //   const whiteboardDom = $('.bjy-whiteboard')[0]
    //   // console.log('1111', presenterDom, whiteboardDom)
    //   // this.changePosition(presenterDom, whiteboardDom)
    //   this.swap(presenterDom, whiteboardDom)
    //   // eventEmitter.trigger(eventEmitter.WINDOW_RESIZE)
    // },
  },
}
</script>
<style lang="less">
@import './index.less';
</style>
<style lang="scss">
@import "./assets/iconfont/iconfont.css";

#watch {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: calc(100vh - 60px);
  width: 100%;

  #main {
    position: absolute;
    top: 60px;
    width: 100%;
    height: calc(100vh - 60px);
    opacity: 1;
    overflow: hidden;

    .class-panel {
      position: absolute;
      top: 0;
      left: 0;
      right: 290px;
      bottom: 40px;
      background-image: url("./assets/img/class-panel-bg.jpg");

      .start-btn {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        background: #1795ff;
        border-radius: 5px;
        width: 100px;
        height: 50px;
        line-height: 50px;
        color: #fff;
        text-align: center;
        font-size: 22px;
        cursor: pointer;
      }

      .bjy-popup {
        display: none;
      }
    }

    .media-panel {
      position: absolute;
      width: 290px;
      top: 0;
      right: 0;
      bottom: 40px;
      padding: 8px 12px;
      box-sizing: border-box;
      background: #fff;
      box-shadow: -2px 0 6px rgba(0, 0, 0, 0.1);
      z-index: 1;

      .live-teacher-player {
        background: #000;
        height: 200px;
        width: 100%;
      }

      .wrap {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background: #fff;
        padding: 10px 10px 0 10px;

        #live-teacher-player {
          height: 200px;
        }
      }
    }

    .footer {
      z-index: 1;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 40px;
      background-color: #424242;
      display: flex;
      justify-content: space-between;
      padding: 0 15px;
      align-items: center;
      font-size: 15px;
      color: #bdc6cf;
      z-index: 0;
    }
  }
}

#survey-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}

.watch-empty {
  height: calc(100vh - 60px);
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  flex-wrap: nowrap;
  flex-direction: column
}

.icom-empty {
  width: 300px;
  height: 200px;
}

.empty-hint {
  display: flex;
  align-items: center;
  color: #333;
  justify-content: center;
  margin-top: 20px;
}
</style>
